import { PJ } from "app/shared/data/pj";
import { Webcam } from "app/shared/data/webcam";
import { MapLayer } from "app/shared/data/map-layer";
import { BoundingBox } from "app/shared/data/bounding-box";

/** Data for the 'map' screen */
export class ScreenMapData {

    public boundingBox: BoundingBox;
    public mapLayers = new Map<String, MapLayer>();

    constructor() {
      this.mapLayers["pj"] = new MapLayer([], [], true);
      this.mapLayers["webcam"] = new MapLayer([], [], true);
      this.mapLayers["image"] = new MapLayer([], [], true);
      this.mapLayers["robject"] = new MapLayer([], [], true);
      this.boundingBox = new BoundingBox(5.0,44.0,12.0,48.0);
    }


  }


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/data/screen-map-data.ts